import React from "react"
import EditCpdEventTaskList from "../../../features/GMPCourseProvider/EditCpdEventTaskList";

const CpdEventApplication = (props) => {
    return (
        <div>
            <EditCpdEventTaskList />
        </div>
    )
};

export default CpdEventApplication;
